import { AsyncPipe, UpperCasePipe } from '@angular/common';
import { Component, inject } from '@angular/core';
import { TranslocoPipe } from '@jsverse/transloco';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { DividendReInvestSelfServiceComponent } from '@zero/shared/feature-dividend-re-invest/web';
import { ButtonComponent, IconComponent } from '@zero/shared/ui-web-design-system';
import { filter, map } from 'rxjs';
import { BaseComponent } from '../base/base.component';
import { PortfolioReportComponent } from '../portfolio-report/portfolio-report.component';
import { ActivateFtgModalComponent } from './activate-ftg-modal/activate-ftg-modal.component';

@Component({
  selector: 'self-service-depot',
  templateUrl: './depot.component.html',
  standalone: true,
  imports: [
    TranslocoPipe,
    PortfolioReportComponent,
    UpperCasePipe,
    IconComponent,
    DividendReInvestSelfServiceComponent,
    AsyncPipe,
    ButtonComponent,
  ],
})
export class DepotComponent extends BaseComponent {
  public readonly activateFtgAllowed$ = this.customerStateFacade.customerBaseData$.pipe(
    filter((cbd) => !!cbd),
    map(({ fzContractActiveDate, ftgPresent }) => fzContractActiveDate && !ftgPresent),
  );

  public readonly modal = inject(NgbModal);
  public modalContent = ActivateFtgModalComponent;
}
